import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export interface UpdateExistingSupplierButtonInterface {
  id: string;
  name: string;

  // "supplier_type":string
}

export const useUpdateExistingSupplierDraft = () => {
  const [UpdateExistingSupplierDraft] = useAPIAction(
    SuppliersApi,
    async (
      api,
      UpdateExistingSupplierData: UpdateExistingSupplierButtonInterface
    ) => {
      const data = await api.supplierDraftUpdate({
        id: UpdateExistingSupplierData.id,
        controlcenterMelcoModelsUpdateSupplier: {
          name: UpdateExistingSupplierData.name,

          // supplier_type: UpdateExistingSupplierData.supplier_type
        },
      });

      return {
        successMessages: [],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "" }
  );

  return useCallback(
    async (UpdateActionDetails: UpdateExistingSupplierButtonInterface) => {
      return await UpdateExistingSupplierDraft(UpdateActionDetails);
    },
    [UpdateExistingSupplierDraft]
  );
};
